import { Atom } from "effect/unstable/reactivity";

import { hostEnvironment } from "../connection/hostEnvironment";

export const primaryEnvironmentIdAtom = Atom.make((get) => {
  for (const environmentId of get(hostEnvironment.environmentEntriesValueAtom).entries.keys()) {
    return environmentId;
  }
  return null;
}).pipe(Atom.withLabel("web-primary-environment-id"));
